{
  "machines": {
    "furnace": {
      "name": "Horno",
      "recipe": "iron_plate",
      "size": [2, 2],
      "speed": 1,
      "in": { "cell": [0, 0], "side": "W" },
      "out": { "cell": [1, 0], "side": "E" }
    },
    "press": {
      "name": "Prensa",
      "recipe": "gear",
      "size": [2, 2],
      "speed": 1,
      "in": { "cell": [0, 0], "side": "W" },
      "out": { "cell": [1, 0], "side": "E" }
    }
  },
  "belt": { "name": "Cinta", "rate": 60 }
}
